// extracted by mini-css-extract-plugin
export default {"header":"xcl5oKqH","headerText":"zFHf0lsM","headerSubtext":"URayAnwl","footer":"DmC62ykH","footerText":"w2ZJUWeL","linkContainer":"hrBjhQWA","submitButton":"H1XGGD3M"};